import { render, staticRenderFns } from "./ScreenBillOfLadingQrView.vue?vue&type=template&id=a6865452&scoped=true&"
import script from "./ScreenBillOfLadingQrView.vue?vue&type=script&lang=js&"
export * from "./ScreenBillOfLadingQrView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6865452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
